import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/Layout'

export const constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/admin/profile',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/admin/profile',
        component: () => import('@/views/profile/index')
      }
    ]
  },
  {
    path: '/admin/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/dashboard',
    children: [
      {
        path: '/admin/dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: {title: 'dashboard', icon: 'dashboard', noCache: true}
      }
    ]
  },
  {
    path: '/admin/cert',
    component: Layout,
    redirect: '/admin/cert',
    children: [
      {
        path: '/admin/cert',
        component: () => import('@/views/cert/index'),
        name: 'Dashboard',
        meta: {title: 'cert', icon: 'dashboard', noCache: true}
      }
    ]
  },
  {
    path: '/admin/insurance',
    component: Layout,
    redirect: '/admin/insurance',
    children: [
      {
        path: '/admin/insurance',
        component: () => import('@/views/insurance/index'),
        name: 'Dashboard',
        meta: {title: 'cert', icon: 'dashboard', noCache: true}
      }
    ]
  },
  {
    path: '/query_cert',
    component: () => import('@/views/home/certQuery'),
  },
  {
    path: '/result',
    component: () => import('@/views/home/resultOk'),
  },
  {
    path: '/mobile',
    component: () => import('@/views/home/mobile'),
  },
  {
    path: '/insurance',
    component: () => import('@/views/home/insurance'),
  },
  {
    path: '/ins_mobile_index',
    component: () => import('@/views/home/insmobileStep0'),
  },
  {
    path: '/ins_mobile',
    component: () => import('@/views/home/insmobileStep1'),
  },
  {
    path: '/ins_mobile2',
    component: () => import('@/views/home/insmobileStep2'),
  },
  {
    path: '/ins_result',
    component: () => import('@/views/home/insmobileResult'),
  },
  {
    path: '',
    component: () => import('@/views/home/index'),
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js